



















import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import {
    createWeekdaySelectorValue,
    DEFAULT_SELECTED_WEEKDAY_VALUES,
    normalizeWeekdaySelectorValue,
    WeekdaySelectorCaptions,
    WeekdaySelectorDay,
    WeekdaySelectorValue,
    WEEKDAY_TRANSLATION_KEYS,
} from './models.ts';

export default {
    name: 'CoWeekdaySelector',
    components: {
        CoRoundButton,
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    props: {
        value: {
            type: Array,
            default: () => [] as WeekdaySelectorDay[],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        defaultSelectedValues: {
            type: Array,
            default: () => [...DEFAULT_SELECTED_WEEKDAY_VALUES],
        },
    },
    computed: {
        translatedCaptions(): WeekdaySelectorCaptions {
            // Rebuild captions from i18n so locale changes update the visible weekday labels.
            const captions = {} as WeekdaySelectorCaptions;

            Object.entries(WEEKDAY_TRANSLATION_KEYS).forEach(([value, translationKey]) => {
                captions[Number(value) as WeekdaySelectorValue] = String(this.$t(translationKey));
            });

            return captions;
        },
        normalizedWeekdays(): WeekdaySelectorDay[] {
            return normalizeWeekdaySelectorValue(
                this.value,
                this.translatedCaptions,
                this.defaultSelectedValues as WeekdaySelectorValue[]
            );
        },
    },
    created() {
        this.emitDefaultValue();
    },
    methods: {
        emitDefaultValue() {
            // Provide a default v-model payload when the component is mounted without a value.
            if (Array.isArray(this.value) && this.value.length > 0) {
                return;
            }

            this.$emit(
                'input',
                createWeekdaySelectorValue(
                    this.translatedCaptions,
                    this.defaultSelectedValues as WeekdaySelectorValue[]
                )
            );
        },
        toggleWeekday(weekdayValue: WeekdaySelectorValue) {
            if (this.disabled) {
                return;
            }

            const updatedWeekdays = this.normalizedWeekdays.map((weekday) => ({
                ...weekday,
                state: weekday.value === weekdayValue ? !weekday.state : weekday.state,
            }));

            this.$emit('input', updatedWeekdays);
            this.$emit('change', updatedWeekdays);
        },
    },
};
